import { useMutation } from "@tanstack/react-query"
import axios from "axios"
import { CreateReferralLeadSchema } from "schema"
import { z } from "zod"

type Props = z.input<typeof CreateReferralLeadSchema>

export function useCreateReferralMutation() {
  return useMutation({
    mutationFn: async (data: Props) => axios.post("/referrals", data),
  })
}
